/*
 * Birthstone gift notice
 *
 * Tells the shopper what unlocks their free necklace. Without it the gift sits in the
 * cart at full price with no explanation until they happen to cross the threshold,
 * which reads as being charged for something the email promised was free.
 *
 * Spend is counted the same way free-gift.js counts it: the gift itself never counts
 * toward its own threshold, and neither do the excluded variants.
 */
(function () {
  'use strict';

  var cfg = window.WVFreeGift;
  if (!cfg || !cfg.enabled || !cfg.threshold) return;

  var GIFT_IDS = (cfg.giftVariantIds || [cfg.variantId]).map(Number);
  var EXCLUDED = (cfg.excludedVariantIds || []).map(Number);
  var THRESHOLD = Number(cfg.threshold); // cents

  var isGift = function (item) { return GIFT_IDS.indexOf(item.variant_id) !== -1; };
  var counts = function (item) {
    return !isGift(item) && EXCLUDED.indexOf(item.variant_id) === -1;
  };

  function money(cents) {
    var v = cents / 100;
    // Whole dollars stay whole: "$12", not "$12.00".
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  // "April - Clear Crystal" -> "Clear Crystal". Falls back to a neutral word so the
  // sentence still reads if the gift is not in the cart yet.
  function stoneName(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGift(cart.items[i])) {
        var t = String(cart.items[i].variant_title || '');
        var parts = t.split(' - ');
        if (parts.length > 1) return parts[1].trim();
      }
    }
    // Not in the cart -- free-gift.js pulls it out below the threshold -- so fall back
    // to the month this browser remembers from the popup or the email link.
    var STONES = {
      January: 'Garnet', February: 'Amethyst', March: 'Aquamarine', April: 'Clear Crystal',
      May: 'Emerald', June: 'Alexandrite', July: 'Ruby', August: 'Peridot',
      September: 'Sapphire', October: 'Tourmaline', November: 'Citrine', December: 'Tanzanite'
    };
    try {
      var m = localStorage.getItem('wvBirthMonth') || sessionStorage.getItem('wvBirthMonth');
      if (m && STONES[m]) return STONES[m];
    } catch (e) {}
    return 'birthstone';
  }

  // Same gate as free-gift.js: only people in the birthstone funnel can have the gift
  // zeroed, so only they are told about it. Everyone else sees the store unchanged.
  // The CODE is the entitlement. A remembered birth month only tells us which stone to
  // name -- it does not make anyone eligible, so it must not gate the promise. Without
  // the code the gift can never be zeroed, and saying otherwise is a false promise.
  function hasCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (cfg.giftCode && codes[i] && codes[i].code === cfg.giftCode) return true;
    }
    return false;
  }

  function render(cart) {
    var hosts = document.querySelectorAll('[data-wv-gift-notice]');
    if (!hosts.length) return;

    if (!hasCode(cart)) {
      Array.prototype.forEach.call(hosts, function (h) { h.hidden = true; h.innerHTML = ''; });
      return;
    }

    var spend = 0;
    cart.items.forEach(function (i) { if (counts(i)) spend += i.line_price; });
    var remaining = THRESHOLD - spend;

    // "Free" is only true when the line is present AND actually priced at zero. Spend
    // alone is not proof: the discount could be inapplicable, expired, or already used.
    var giftLine = null;
    for (var g = 0; g < cart.items.length; g++) {
      if (isGift(cart.items[g])) { giftLine = cart.items[g]; break; }
    }
    var earned = remaining <= 0 && giftLine !== null && giftLine.final_line_price === 0;
    var pct = Math.max(0, Math.min(100, Math.round((spend / THRESHOLD) * 100)));
    var stone = stoneName(cart);

    // Never hidden while the offer is on. An empty cart is precisely when the shopper
    // needs telling -- the gift was just removed from under them by the threshold rule.
    var hide = false;

    var html = earned
      ? '<p class="wv-gift-notice__text"><strong>Your ' + stone +
        ' necklace is free.</strong> It comes off at checkout.</p>'
      : '<p class="wv-gift-notice__text">Add <strong>' + money(remaining) +
        '</strong>' + (spend > 0 ? ' more' : ' of anything') +
        ' and your <strong>' + stone + '</strong> necklace is free.</p>' +
        '<div class="wv-gift-notice__track" role="progressbar" aria-valuemin="0" ' +
        'aria-valuemax="100" aria-valuenow="' + pct + '">' +
        '<span class="wv-gift-notice__bar" style="width:' + pct + '%"></span></div>';

    Array.prototype.forEach.call(hosts, function (host) {
      host.hidden = hide;
      if (hide) { host.innerHTML = ''; return; }
      host.className = 'wv-gift-notice' + (earned ? ' wv-gift-notice--earned' : '');
      if (host.innerHTML !== html) host.innerHTML = html;
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  // Re-read after anything that changes the cart. free-gift.js adds and removes the
  // gift itself, so the notice has to follow its writes as well as the shopper's.
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(href)) {
        p.then(function () { setTimeout(refresh, 120); }).catch(function () {});
      }
      return p;
    };
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-free-gift-add], .cart-remove-button')) {
      setTimeout(refresh, 400);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  document.addEventListener('shopify:section:load', refresh);

  // Shopify's cart section re-renders after load and can replace our markup with the
  // empty mount point again. Watch for that and re-fill it rather than racing it.
  var watchdog = setInterval(function () {
    var host = document.querySelector('[data-wv-gift-notice]');
    if (host && !host.hidden && host.innerHTML === '') refresh();
  }, 700);
  setTimeout(function () { clearInterval(watchdog); }, 12000);
})();
